import React from 'react';
import HeaderSearch from './header-parts/HeaderSearch';
import Logo from './header-parts/Logo';
import ProfileDropdown from './header-parts/ProfileDropdown';
export default function Header() {

    return (
        <div className='site-header'>
            <div className="row align-items-center">
                <div className="col-md-3">
                    <Logo />
                </div>
                <div className="col-md-6">
                    <HeaderSearch />
                </div>
                <div className="col-md-3">
                    <div className="right-menu-wrap align-items-center d-flex justify-content-end">
                        <ProfileDropdown />
                    </div>
                </div>
            </div>
        </div >
    )
}
